import { AbstractControl, ValidationErrors } from '@angular/forms';

export function quizNameValidator(control: AbstractControl): ValidationErrors | null {

	const value = control.value?.trim() || '';
	if (!value) return null;
	if (value.length >= 100) {
		return {
			maxLength: true
		};
	}

    const regex = /^[a-zA-Z0-9 ()-]+$/;
    return regex.test(value) ? null : { invalidQuizName: true };
}